import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { User } from "../images";
import {
  BackArrowIcon,
  ExportIcon,
  LogoutIcon,
  RefreshIcon,
  ReloadIcon,
} from "../icon/icon";
import { useFetchAndSyncData } from "../hooks";
import { useSelector } from "react-redux";
import { nameFormatting } from "../helpers/commonFunction";
import { Loader } from "../components";
import {
  OfflineModal,
  ImportDataModal,
  ConfirmationModal,
} from "../components/Modals";
import { headerChildPages, SYNC_TYPE } from "../helpers/constants";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loader, user } = useSelector((state) => state.userReducer);
  const { fetchLoader, syncLoader, initialSyncLoader } = useSelector(
    (state) => state.offlineReducer,
  );
  const [isOpen, setIsOpen] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const handleShowImportModal = () => {
    setIsOpen(false);
    setShowImportModal(!showImportModal);
  };

  const {
    syncType,
    syncMessage,
    offlineModal,
    confirmationModal,
    handleOfflineModal,
    handleConfirmModal,
    uploadAndFetchData,
  } = useFetchAndSyncData();

  const handleSyncData = (type) => {
    setIsOpen(false);
    uploadAndFetchData(type);
  };

  const handleImportDBData = async (type, file) => {
    setIsOpen(false);
    await uploadAndFetchData(type, file);
    handleShowImportModal();
  };

  const handleBackNavigation = () => {
    navigate(-1);
  };

  return (
    <>
      {(fetchLoader || syncLoader || initialSyncLoader || loader) && <Loader />}
      <header className="tc-navbar">
        {headerChildPages.includes(location.pathname) ? (
          <div className="fog_back_button_navbar">
            <button
              type="button"
              className="tc-navbar-back-btn me-0"
              onClick={() => handleBackNavigation()}
            >
              {BackArrowIcon}
            </button>
            <p className="tc-navbar-title">
              {location?.state?.title ? location?.state?.title : ""}
            </p>
            <button className="c-pointer"></button>
          </div>
        ) : (
          <div className="tc-navbar-content">
            <span className="tc-navbar-user-name">TCL Personnel App</span>
            <Dropdown
              show={isOpen}
              onToggle={() => setIsOpen(!isOpen)}
              className="tc-navbar-profile-dropdown ms-auto"
            >
              <Dropdown.Toggle className="tc_navbar_user_profile">
                <span className="tc_navbar_user_profile_name">
                  {user && nameFormatting(user, "LF")}
                </span>
                <img src={User} alt="userPhoto" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as="button"
                  className="tc_navbar_profile_dropdown_item dropdown-item"
                  onClick={() => handleSyncData(SYNC_TYPE.SYNC)}
                >
                  <span className="d-flex align-items-center">
                    <span className="me-2">{RefreshIcon}</span>
                    Refresh
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  className="tc_navbar_profile_dropdown_item dropdown-item"
                  onClick={() => window.location.reload(true)}
                >
                  <span className="d-flex align-items-center">
                    <span className="me-2">{ReloadIcon}</span>
                    Reload App
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  className="tc_navbar_profile_dropdown_item dropdown-item"
                  onClick={() => handleSyncData("export")}
                >
                  <span className="d-flex align-items-center">
                    <span className="me-2">{ExportIcon}</span>
                    Export DB
                  </span>
                </Dropdown.Item>
                {/* <button
                  type="button"
                  className="tc_navbar_profile_dropdown_item dropdown-item tc_profile_dropdown_border"
                  onClick={() => handleShowImportModal()}
                >
                  <span className="d-flex align-items-center">
                    <span className="me-2">{ExportIcon}</span>
                    Import DB
                  </span>
                </button> */}
                <Dropdown.Item
                  as="button"
                  className="tc_navbar_profile_dropdown_item dropdown-item"
                  onClick={() => handleSyncData(SYNC_TYPE.LOGOUT)}
                >
                  <span className="d-flex align-items-center">
                    <span className="me-2">{LogoutIcon}</span>
                    Logout
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </header>
      {offlineModal && (
        <OfflineModal show={offlineModal} onHide={handleOfflineModal} />
      )}
      {confirmationModal && (
        <ConfirmationModal
          show={confirmationModal}
          onHide={handleConfirmModal}
          title="Syncing Data"
          subTitle="Failed to sync data!"
          description="Please resync the data!"
          cancel="Cancel"
          save="Syncing"
          errorMessage={syncMessage}
          onSubmit={() => handleSyncData(syncType)}
        />
      )}
      {showImportModal && (
        <ImportDataModal
          show={showImportModal}
          onHide={handleShowImportModal}
          onSubmit={handleImportDBData}
        />
      )}
    </>
  );
};

export default Header;
